import styled from "styled-components";

export const Component = styled.div`
  color: #000 !important;
`;
